/* eslint-disable consistent-return */
/* eslint-disable comma-dangle */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-accessible-accordion/dist/fancy-example.css';

import {
  Container,
  ViewFormPersonal,
  ViewFormLocal,
  ViewFormPassword,
  ViewBottom,
} from './styles';
import { updateProfileRequest } from '~/store/modules/user/actions';

import BrData from '~/assets/data/brcities.json';

export default function SignUp() {
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.profile);

  const [firstName, setFirstName] = useState(user.first_name);
  const [lastName, setLastName] = useState(user.last_name);
  const [email, setEmail] = useState(user.email);
  const [city, setCity] = useState(user.city);
  const [state, setState] = useState(user.state);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [stateSelected, setStateSelected] = useState('');
  const [citySelected, setCitySelected] = useState('');

  async function handleSelectState(e) {
    setStateSelected(e.target.value);
    const states = [
      'AC',
      'AL',
      'AM',
      'AP',
      'BA',
      'CE',
      'DF',
      'ES',
      'GO',
      'MA',
      'MG',
      'MS',
      'MT',
      'PA',
      'PB',
      'PE',
      'PI',
      'PR',
      'RJ',
      'RN',
      'RO',
      'RR',
      'RS',
      'SC',
      'SE',
      'SP',
      'TO',
    ];
    setState(states[e.target.value]);
  }

  async function handleSelectCity(e) {
    setCitySelected(e.target.value);
    setCity(e.target.value);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const { id } = user;

    if (password === confirmPassword) {
      dispatch(
        updateProfileRequest(
          firstName,
          lastName,
          email,
          city,
          state,
          password,
          id
        )
      );
    } else {
      return toast.error('As senhas precisam ser iguais.');
    }
  }

  window.scrollTo(0, 0);

  return (
    <Container>
      <h1>Editar Perfil</h1>
      <div className="main-edit">
        <form ref={formRef} onSubmit={(e) => handleSubmit(e)}>
          <p
            style={{
              color: '#fff',
              textAlign: 'center',
              marginTop: 40,
              fontSize: 24,
            }}
          >
            Dados Pessoais
          </p>
          <ViewFormPersonal>
            <div className="support">
              <p>Nome:</p>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="support">
              <p>Sobrenome:</p>
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
            <div className="support">
              <p>E-mail:</p>
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </ViewFormPersonal>
          {/* <input
            type="text"
            value={birthday}
            onChange={e => setBirthday(e.target.value)}
          /> */}
          <p
            style={{
              color: '#fff',
              textAlign: 'center',
              marginTop: 30,
              fontSize: 24,
            }}
          >
            Local Atual{' '}
            <p
              style={{
                color: '#fff',
                textAlign: 'center',
                marginTop: 5,
                fontSize: 18,
              }}
            >
              {city}/{state}
            </p>
          </p>
          <ViewFormLocal>
            <div className="support">
              <p>Estado: {state}</p>
              <select value={stateSelected} onChange={handleSelectState}>
                <option value="" disabled>
                  Selecione o estado que você mora
                </option>
                {BrData.estados.map((item, index) => (
                  <option key={item.sigla} value={index}>
                    {item.nome}
                  </option>
                ))}
              </select>
            </div>
            <div className="support">
              <p>Cidade: {city}</p>
              {stateSelected === '' ? null : (
                <select value={citySelected} onChange={handleSelectCity}>
                  <option value="" disabled>
                    Selecione a cidade que você mora
                  </option>
                  {BrData.estados[stateSelected].cidades.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              )}
            </div>
          </ViewFormLocal>
          <p
            style={{
              color: '#fff',
              textAlign: 'center',
              marginTop: 30,
              fontSize: 24,
            }}
          >
            Alterar Senha
          </p>
          <ViewFormPassword>
            <div className="support">
              <p>Nova Senha:</p>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Digite sua nova senha"
              />
            </div>
            <div className="support">
              <p>Confirmar Nova Senha:</p>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirme sua nova senha"
              />
            </div>
          </ViewFormPassword>

          <ViewBottom>
            <button type="submit">SALVAR</button>
          </ViewBottom>
        </form>
      </div>
    </Container>
  );
}
